/**
 * @fileoverview A general cross component. Used by the EasingCross and some tooltips.
 */

import React from 'react'

class EasingCross extends React.PureComponent {
  static defaultProps = {
    x: 0,
    y: 0,
    r: 2,
    // larger than circles, even with the same radius, because they extend
    // to each corner
    inset: 0.2
  }

  render() {
    const { inset, x, y, r, ...props } = this.props

    let size = r * (1 - inset)

    let x1 = x - size
    let x2 = x + size
    let y1 = y - size
    let y2 = y + size

    return (
      <g {...props}>
        <line x1={x1} x2={x2} y1={y1} y2={y2} />
        <line x1={x1} x2={x2} y1={y2} y2={y1} />
      </g>
    )
  }
}

export default EasingCross



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/cross.js